import { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import TopNav from "../components/TopNav";
import { useNavigate } from "react-router-dom";
import "../App.css";

function AdminPanel() {
  const [applications, setApplications] = useState([]);
  const [users, setUsers] = useState([]);
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApplications = async () => {
      const jobCollection = await getDocs(collection(db, "items"));
      const apps = [];
      for (const job of jobCollection.docs) {
        const jobId = job.id;
        const usersSnap = await getDocs(
          collection(db, `applicated/${jobId}/users`)
        );
        usersSnap.forEach((doc) => {
          apps.push({ ...doc.data(), jobId });
        });
      }
      setApplications(apps);
    };

    const fetchUsers = async () => {
      const snapshot = await getDocs(collection(db, "users"));
      const allUsers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(allUsers);
    };

    const fetchJobs = async () => {
      const snapshot = await getDocs(collection(db, "items"));
      const jobData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setJobs(jobData);
    };

    fetchApplications();
    fetchUsers();
    fetchJobs();
  }, []);

  const handleDelete = async (jobId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this job?"
    );
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "items", jobId));
      setJobs((prev) => prev.filter((job) => job.id !== jobId));
      alert("Job deleted successfully.");
    } catch (err) {
      alert("Failed to delete job: " + err.message);
    }
  };

  return (
    <div className="admin-dashboard">
      <TopNav />
      <div className="admin_section">
        <div className="admin-header">
          <h2>Admin Dashboard</h2>
        </div>

        <div className="admin-stats">
          <div className="stat-card green">
            <h3>{jobs.length}</h3>
            <p>All Jobs</p>
          </div>
          <div className="stat-card orange">
            <h3>{users.length}</h3>
            <p>Registered Users</p>
          </div>
          <div className="stat-card blue">
            <h3>{applications.length}</h3>
            <p>Applications</p>
          </div>
        </div>

        <div className="admin-tables">
          <div className="table-section">
            <h3>Job Items</h3>
            <table>
              <thead>
                <tr>
                  <th>Job ID</th>
                  <th>Name</th>
                  <th>Place</th>
                  <th>Type</th>
                  <th>Category</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((job) => (
                  <tr key={job.id}>
                    <td>{job.name}</td>
                    <td>{job.place}</td>
                    <td>{job.type}</td>
                    <td>{job.salary}</td>
                    <td className="button_section"> 
                      <button
                        className="edit-btn"
                        onClick={() => navigate(`/edit/${job.id}`)}
                      >
                        Edit
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(job.id)}
                        style={{ marginLeft: "8px" }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
